import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import {DataGridPro, GridToolbar} from '@mui/x-data-grid-pro';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';


export default function REPLoadsDueDetailList(props){
    //console.debug("RTS Break REPLoadsDueDetailList");

    const history = useNavigate();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));


    const columns = [
        {
            field: 'curReelSerialNumber', 
            headerName: "Reel", 
            description:"Reel Serial Number", 
            flex:1,
        },
        {
            field: 'reelTypeName', 
            headerName: "Reel Type", 
            description:"Reel Type", 
            flex:1,
        },  
        {
            field: 'curAliasName', 
            headerName: "Product", 
            description:"Product Name", 
            flex:4,
        },
        {
            field: 'customerPo', 
            headerName: "P.O.", 
            description:"Purchase Order", 
            flex:1,
        },

        {
            field: 'deferralPeriod', 
            headerName: "Deferral (Months)", 
            description:"Deferral Period", 
            flex:1,
            valueGetter: (value, row) => {
                return row.deferralPeriod.toLocaleString()
            },
            type:'number',
        },
        {
            field: 'shipDate', 
            headerName: "Date Shipped", 
            description:"Reel Ship Date", 
            flex:1,
            valueGetter: (value, row) => {
                if(value == null){
                    return null;
                }

                return (
                    new Date(value)
                );
            },
            type:"date",
            valueFormatter: (value) => {
                if(value == null){
                    return null;
                }
                
                const formatObj = new Intl.DateTimeFormat("en-US");
                return (
                    formatObj.format(new Date(value))
                );
            },      
        },
        {
            field: 'deferralDaysLeft', 
            headerName: "Days Left", 
            description:"Deferral Days Left", 
            flex:1,
            valueGetter: (value, row) => {
            
                let curVal = '';
                if(row.deferralDaysLeft>=0){
                    curVal = row.deferralDaysLeft.toLocaleString();
                }
                else{
                    curVal = row.deferralDaysLeft.toLocaleString();
                }
                return curVal;
            },
            type:'number',
        }                
    ];


    function getVisibilityModel(){
        if(smallForm){
            return {}
        }
        else{
            return {}
        }
    }


    function getDensity(){
        if(smallForm){
            return "comfortable";
        }
        else{
            return "standard";
        }
    }


    return (
        <Box sx={{width:'100%', height:'100%', minHeight:'400px'}}>
            <DataGridPro
                pagination={true}
                slots={{toolbar: GridToolbar}}
                slotProps={{
                    toolbar:{
                        showQuickFilter:true,
                    }
                }}
                rows={props.data} 
                columns={columns} 
                getRowId={row => row.idGuid} 
                initialState={{
                    columns:{
                        columnVisibilityModel: getVisibilityModel()
                    },
                    pagination: { paginationModel: { pageSize: 50 } },
                    density: getDensity() 
                }}                
            />
        </Box>
    );
}